import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash} from '@fortawesome/free-solid-svg-icons'
export const DeleteButton = ({setId, statusId, setShowDeleteConfirmPop}) => {

    const handleShow = () => {
        setId(statusId)
        setShowDeleteConfirmPop(true)
    }

    return(
        <React.Fragment>
           <div className="custom-button">
            <FontAwesomeIcon className="delete-button-icon" icon={faTrash} onClick={() => handleShow()} ></FontAwesomeIcon>
           </div>
        </React.Fragment>
    )
}